import React, { Component } from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Table, Icon } from 'semantic-ui-react'
import { firebaseAuth, pythonApiIp, toCurrency } from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';

import {RenderEditProjectCost} from './UiUtils'


class ViewLargeProjectCosts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            customers: [],
            projectCosts: [],
            totalCost: 0,
            modalOpen: false,
        }
    }

    componentDidMount() {
        console.log("addx2 ++++++++++ searchNow componentDidMount");


        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)

                    //IF ITS SENT FROM VIEW SINGLE LARGE PROJECT.. PROJECT COSTS ARE ALREADY PROVIDED..
                    if (this.props.projectCosts) {
                        console.log("projectCosts sent...");
                        this.setState({
                            projectCosts: this.props.projectCosts
                        })
                        //GET TOTAL COSTS
                        this.getProjectTotalCost(this.props.projectCosts)
                    } else {
                        //this.getProjectCosts();
                    }

                }


            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    getProjectTotalCost = (projectCosts) => {
        console.log("gtx1 get total project cost")
        console.log("gtx1 project costs:" + projectCosts.length)

        let total = 0;
        projectCosts.forEach(element => {
          //  console.log("gtx10 get element cost:" + (element.qty * element.cost))
            total += (element.qty * element.cost)
           // console.log("gtx12 new total:" + total)
        });

        this.setState({
            totalCost: total
        })
    }


    getProjectCosts = () => {
        console.log("++++++++:getProjectCosts");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getProjectCosts', {
            apiKey: "PrintB@da7",
            projectId: this.props.projectId
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. adding customer");
                    console.log("svx1ViewLarge: porjectCosts:" + JSON.stringify(response.data.projectCosts, null, 3))
                    this.setState({
                        projectCosts: response.data.projectCosts
                    })
                    //GET TOTAL COSTS
                    this.getProjectTotalCost(response.data.projectCosts)
                } else {
                    console.log("FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }

    openModal = () => {
        this.setState({ modalOpen: true });
    }

    closeModal = () => {
        this.setState({ modalOpen: false });
    }

    render() {


        const CostApprovedRow = (item) =>
            item.costapproved == 'yes'
                ? <Table.Cell>
                    <Icon name='checkmark' />
                    Approved
              </Table.Cell>
                : <Table.Cell> {item.costapproved} </Table.Cell>


        const rows = this.state.projectCosts.length > 0
            ? this.state.projectCosts.map((item) =>
                <Table.Row>
                    <Table.Cell> {item.shirttypes.shirttype} </Table.Cell>
                    <Table.Cell> {item.qty} </Table.Cell>
                    <Table.Cell> {toCurrency(item.cost)} </Table.Cell>
                    {/* <Table.Cell> {item.addedby} </Table.Cell> */}
                    <Table.Cell> {toCurrency(item.qty * item.cost)} </Table.Cell>
                    <Table.Cell> {item.description} </Table.Cell>
                    <Table.Cell> {item.datetimeadded} </Table.Cell>
                    <Table.Cell> {item.logged} </Table.Cell>
                    <Table.Cell> <Link to={'/dashboard/editProjectCost/' + this.props.projectId + '/' + item.idlargeprojectcosts+ '/desktop'}>EDIT</Link> </Table.Cell>
                    <Table.Cell> {item.costapproved} </Table.Cell>
                    <RenderEditProjectCost item={item} costId={item.idlargeprojectcosts} projectId={this.props.projectId} user={this.props.user}/>
                    {/* <Table.Cell> <CostMarkProjectCost costId={item.idlargeprojectcosts} projectId={this.props.projectId}/> </Table.Cell> */}
                    {/* <CostApprovedRow item={item}/>  */}

                </Table.Row>)
            : ''

            
        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <h2>PROJECT COSTS</h2>
                <h3> TOTAL COST:{toCurrency(this.state.totalCost)}</h3>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Item</Table.HeaderCell>
                            <Table.HeaderCell>qty</Table.HeaderCell>
                            <Table.HeaderCell>cost</Table.HeaderCell>
                            <Table.HeaderCell>Total Cost</Table.HeaderCell>
                            <Table.HeaderCell>description</Table.HeaderCell>
                            <Table.HeaderCell>Date Spent</Table.HeaderCell>
                            <Table.HeaderCell>Logged</Table.HeaderCell>
                            <Table.HeaderCell>EDIT</Table.HeaderCell>
                            <Table.HeaderCell>APPROVED</Table.HeaderCell>
                            <Table.HeaderCell>ACTION</Table.HeaderCell>

                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {rows}
                    </Table.Body>

                </Table>

            </div>
        );
    }
}

export default ViewLargeProjectCosts;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ViewLargeProjectCosts.js